import axios from 'axios';

export type Planner = {
  id: number;
  userName?: string;
  nickname?: string;
  loginId?: string;
  activeYn?: number;
};

export type ReservationOpenSlot = {
  id: number;
  slotDate: string;
  shopId?: number;
  shopName: string;
  startTimeCode: number | string;
  endTimeCode?: number | string;
};

export type PlannerReservation = {
  id: number;
  reservationCode?: string;
  customerName: string;
  reservedTime: string;
  reservationStatus?: 'BOOKED' | 'CANCELED' | string;
  openSlots?: ReservationOpenSlot[];
};

export type MovePlannerReservationsPayload = {
  reservationIds: number[];
};

export async function getPlanners() {
  const response = await axios.get('/api/admin/planners');
  return response.data;
}

export async function getPlannerReservations(
  plannerId: number,
  reservationIds?: number[],
) {
  const response = await axios.get(
    `/api/admin/planners/${plannerId}/reservations`,
    {
      params: {
        reservationIds: reservationIds?.length
          ? reservationIds.join(',')
          : undefined,
      },
    },
  );
  return response.data;
}

export async function movePlannerReservations(
  plannerId: number,
  payload: MovePlannerReservationsPayload,
) {
  const response = await axios.post(
    `/api/admin/planners/${plannerId}/reservations/move`,
    payload,
  );
  return response.data;
}
